module.exports = __webpack_public_path__ + "img/f4.b2088877.png";